<template>
    <div class="speed-data-section">
        <div class="section-title">四、综合分析与评估：</div>
        <el-card>

            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <span v-if="fuelType == 2">1、怠速时间占发动机运行时间的百分比为</span>
                <span v-else>1、怠速时间占电机运行时间的百分比为</span>
                <span style="margin-left: 50px;">{{ vehicleStatus.period.IdleRatio ?? 0 }} %</span>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <span v-if="fuelType == 2">2、发动机经济转速区占工作区的百分比为</span>
                <span v-else>2、电机经济转速区占工作区的百分比为</span>
                <span style="margin-left: 50px;">{{ engineLoadChart.PieChart.EconPer ?? 0 }} %</span>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>3、该统计时段平均燃耗</span>
                    <span style="margin-left: 50px;">{{ fuelType == 1
                        ? (vehicleStatus.period.AvgElecConsume ?? 0) : (vehicleStatus.period.PerOilConsume ?? 0) }} {{
                            fuelType
                                == 1 ? 'kwh/100km' : 'L/100km' }}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>平均车速</span>
                    <span style="margin-left: 50px;">{{ vehicleStatus.period.AvgSpeed ?? 0 }} km/h</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>4、车辆冷却水温度在70-105℃运行时长为</span>
                    <span style="margin-left: 50px;">{{ waterTempSumHour }} 小时</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>所占百分比是</span>
                    <span style="margin-left: 50px;">{{ waterTempSumPercent }} %</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>整个运行过程中最低温度为</span>
                    <span style="margin-left: 50px;">{{ basicInfo.MinWaterTemp ?? 0 }} ℃</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>最高温度为</span>
                    <span style="margin-left: 50px;">{{ basicInfo.MaxWaterTemp ?? 0 }} ℃</span>
                </div>
            </div>
            <div v-if="false" style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>5、车辆机油压力在100-700pka的运行时长为</span>
                    <span style="margin-left: 50px;">{{ oilPressSumHour }} 小时</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>所占百分比是</span>
                    <span style="margin-left: 50px;">{{ oilPressSumPercent }} %</span>
                </div>
            </div>
            <div  v-if="false" style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>整个运行过程中最低温度为</span>
                    <span style="margin-left: 50px;">{{ basicInfo.MinOilPress ?? 0 }} ℃</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>最高压力</span>
                    <span style="margin-left: 50px;">{{ basicInfo.MaxOilPress ?? 0 }} ℃</span>
                </div>
            </div>

            <div  v-if="false" style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>6、车辆中冷器温度在35-70℃运行时长为</span>
                    <span style="margin-left: 50px;">{{ gasTempSumHour }} 小时</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>所占百分比是</span>
                    <span style="margin-left: 50px;">{{ gasTempSumPercent }} %</span>
                </div>
            </div>
            <div  v-if="false" style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>整个运行过程中最低温度为</span>
                    <span style="margin-left: 50px;">{{ basicInfo.MinGasTemp ?? 0 }} ℃</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>最高温度为</span>
                    <span style="margin-left: 50px;">{{ basicInfo.MaxGasTemp ?? 0 }} ℃</span>
                </div>
            </div>

            <div  v-if="false" style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>7、蓄电池电压在24-28.8v的运行时长为</span>
                    <span style="margin-left: 50px;">{{ elecVoltSumHour }} 小时</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>所占百分比是</span>
                    <span style="margin-left: 50px;">{{ elecVoltSumPercent }} %</span>
                </div>
            </div>
            <div  v-if="false" style="margin-bottom: 10px;display: flex;align-items: center;">
                <div style="flex:1;display: flex;align-items: center;"> <span>整个运行过程中最低电压</span>
                    <span style="margin-left: 50px;">{{ basicInfo.MinVoltage ?? 0 }} V</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;"> <span>最高电压</span>
                    <span style="margin-left: 50px;">{{ basicInfo.MaxVoltage ?? 0 }} V</span>
                </div>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <span>5、制动蹄片磨损报警</span>
                <el-checkbox-group size="mini" disabled v-model="form.brakeWarn" style="margin-left: 50px;">
                    <el-checkbox label="无">无(正常)</el-checkbox>
                    <el-checkbox label="有">有(异常,应及时更换)</el-checkbox>
                </el-checkbox-group>
            </div>
            <div style="margin-bottom: 10px;display: flex;align-items: center;">
                <span>6、空滤器堵塞报警</span>
                <el-checkbox-group size="mini" disabled v-model="form.filterWarn" style="margin-left: 50px;">
                    <el-checkbox label="无">无(正常)</el-checkbox>
                    <el-checkbox label="有">有(异常,应及时更换)</el-checkbox>
                </el-checkbox-group>
            </div>
            <div style="margin-bottom: 10px;">
                <span>7、本时间段：</span><br />
                <el-checkbox size="mini" disabled v-model="form.operation.good">未见有不良驾驶操作行为，希望保持和发扬；</el-checkbox><br />
                <el-checkbox size="mini" disabled v-model="form.operation.bad">有个别不良驾驶操作行为</el-checkbox><br />
                <div class="op-detail" style="margin-top: 10px; margin-left: 20px;">
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.speed">超速行车</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.overtake">超车行车</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.accel" checked>急加速</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.decel" checked>急减速</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.idle" checked>过长怠速</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.neutral" checked>空档滑行</el-checkbox>
                    <el-checkbox size="mini" disabled v-model="form.operation.detail.ac">怠速开空调</el-checkbox>
                </div>
            </div>
            <div style="margin-bottom: 10px;">
                <span>8、司机得分：</span><br />
                <span>根据对该车在此时间段采集的数据进行分析后总体评价得分：{{ basicInfo.PValue }}分(仅供参考)</span><br />
                <el-checkbox-group size="mini" disabled v-model="form.scoreLevel" style="margin-top: 10px;">
                    <el-checkbox label="优">优(85-100)</el-checkbox>
                    <el-checkbox label="良">良(65-85)</el-checkbox>
                    <el-checkbox label="一般">一般(50-65)</el-checkbox>
                    <el-checkbox label="差">差(0-50)</el-checkbox>
                </el-checkbox-group>
            </div>

        </el-card>
        <div style="border: 1px solid #000; padding: 10px;height: 200px;border-top:0px;">
            评审结论
        </div>
        <div style="border: 1px solid #000;border-top:0px; padding: 10px;height: 160px;position: relative;">
            <div style="position: absolute;left: 0; bottom: 0;right: 0;text-align: right;">
                <el-row style="margin-right: 20px;">
                    <el-col :span="12">
                        <p style="margin-right: 84px;    margin-bottom: 20px;"> 报告人：</p>
                        <p style="margin-bottom: 20px;">年 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 月
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 日</p>
                    </el-col>
                    <el-col :span="12">
                        <p style="margin-right: 84px;    margin-bottom: 20px;">审批：</p>
                        <p style="margin-bottom: 20px;">年 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 月
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 日</p>
                    </el-col>
                </el-row>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: "vehicleReportData",
    props: {
        basicInfo: {
            type: Object,
            default: () => ({})
        },
        vehicleStatus: {
            type: Object,
            default: () => ({
                period: {}
            })
        },
        fuelType: {
            type: Number,
            default: 1
        },
        engineLoadChart: {
            type: Object,
            default: () => ({})
        },
        waterTempChart: {
            type: Array,
            default: () => ([])
        },
        oilPressChart: {
            type: Array,
            default: () => ([])
        },
        gasTempChart: {
            type: Array,
            default: () => ([])
        },
        voltageChart: {
            type: Array,
            default: () => ([])
        },

    },
    watch: {
        vehicleStatus: {
            handler(newVal, oldVal) {
                if (newVal.period.BrakeAlarmCount != 0) {
                    this.form.brakeWarn = ["有"]
                } else {
                    this.form.brakeWarn = ["无"]
                }
                if (newVal.period.LeachCount != 0) {
                    this.form.filterWarn = ["有"]
                } else {
                    this.form.filterWarn = ["无"]
                }
                var speed = false;
                var overtake = false;
                var accel = false;
                var decel = false;
                var idle = false;
                var neutral = false;
                var ac = false;
                var good = false;
                var bad = false;
                if (newVal.period.OverCount1 != 0 || newVal.period.OverCount2 != 0 || newVal.period.OverCount3 != 0) {
                    speed = true;
                }
                if (newVal.period.OverEnCount != 0) {
                    overtake = true;
                }
                if (newVal.period.SpeedUpCount != 0) {
                    accel = true;
                }
                if (newVal.period.SpeedDownCount != 0) {
                    decel = true;
                }
                if (newVal.period.OverIdleCount != 0) {
                    idle = true;
                }
                if (newVal.period.SlideCount != 0) {
                    neutral = true;
                }
                if (newVal.period.AirIdleCount != 0) {
                    ac = true;
                }
                //每个都是false，才是good
                if (!speed && !overtake && !accel && !decel && !idle && !neutral && !ac) {
                    good = true;
                    bad = false;
                } else {
                    good = false;
                    bad = true;
                }



                //超速信息
                this.form.operation = {
                    good: good,
                    bad: bad,
                    detail: {
                        speed: speed,
                        overtake: overtake,
                        accel: accel,
                        decel: decel,
                        idle: idle,
                        neutral: neutral,
                        ac: ac
                    }
                };

                this.form.scoreLevel = [];
                if (this.basicInfo.PValue) {
                    if (this.basicInfo.PValue >= 85) {
                        this.form.scoreLevel.push('优');
                    } else if (this.basicInfo.PValue >= 65) {
                        this.form.scoreLevel.push('良');
                    } else if (this.basicInfo.PValue >= 50) {
                        this.form.scoreLevel.push('一般');
                    } else if (this.basicInfo.PValue >= 0) {
                        this.form.scoreLevel.push('差');
                    }
                }




            },
            deep: true
        },

        waterTempChart: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.waterTempSumHour = 0;
                    this.waterTempSumPercent = 0;
                    //循环newVal数组的第6-10行，将WorkHour和PointPerCent进行累计，并赋值给  waterTempSumHour和waterTempSumPercent
                    if (newVal.length > 8) {
                        for (let i = 6; i <= 9; i++) {
                            this.waterTempSumHour += parseFloat(newVal[i].WorkHour);
                            this.waterTempSumPercent += parseFloat(newVal[i].PointPerCent);
                        }
                    }
                }
            },
            deep: true
        },
        oilPressChart: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.oilPressSumHour = 0;
                    this.oilPressSumPercent = 0;
                    //循环newVal数组的第6-10行，将WorkHour和PointPerCent进行累计，并赋值给  oilPressSumHour和oilPressSumPercent
                    if (newVal.length > 1) {
                        for (let i = 1; i <= 8; i++) {
                            this.oilPressSumHour += parseFloat(newVal[i].WorkHour);
                            this.oilPressSumPercent += parseFloat(newVal[i].PointPerCent);
                        }
                    }
                }
            },
            deep: true
        },
        gasTempChart: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.gasTempSumHour = 0;
                    this.gasTempSumPercent = 0;
                    //循环newVal数组的第6-10行，将WorkHour和PointPerCent进行累计，并赋值给  gasTempSumHour和gasTempSumPercent
                    if (newVal.length > 5) {
                        for (let i = 5; i <= 10; i++) {
                            this.gasTempSumHour += parseFloat(newVal[i].WorkHour);
                            this.gasTempSumPercent += parseFloat(newVal[i].PointPerCent);
                        }
                    }
                }
            },
            deep: true
        },
        voltageChart: {
            handler(newVal, oldVal) {
                if (newVal.length > 0) {
                    this.elecVoltSumHour = 0;
                    this.elecVoltSumPercent = 0;

                    if (newVal.length > 7) {
                        for (let i = 1; i <= 8; i++) {
                            this.elecVoltSumHour += parseFloat(newVal[i].WorkHour);
                            this.elecVoltSumPercent += parseFloat(newVal[i].PointPerCent);
                        }
                    }
                }
            },
            deep: true
        },

    },
    data() {
        return {
            waterTempSumHour: 0,
            waterTempSumPercent: 0,
            oilPressSumHour: 0,
            oilPressSumPercent: 0,
            gasTempSumHour: 0,
            gasTempSumPercent: 0,
            elecVoltSumHour: 0,
            elecVoltSumPercent: 0,
            form: {
                // 8-9项
                brakeWarn: [],
                filterWarn: [],
                // 10项：驾驶操作
                operation: {
                    good: false,
                    bad: false,
                    detail: {
                        speed: false,
                        overtake: false,
                        accel: false,
                        decel: false,
                        idle: false,
                        neutral: false,
                        ac: false
                    }
                },
                // 11项：得分等级
                scoreLevel: []
            }
        };
    },
    mounted() {

    },
    methods: {

    }
};
</script>
<style scoped>
.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
}

.op-group {
    margin-bottom: 5px;
}

.op-detail {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.el-radio,
.el-checkbox {
    margin-right: 20px;
}

::v-deep .el-radio__input.is-disabled+span.el-radio__label {
    color: #303133 !important;
}

::v-deep .el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #303133 !important;
}

::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #fff;
    border-color: #000;
}

::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #000;
}

::v-deep.el-card {
    border: 1px solid #000 !important;
    border-radius: 0px !important;
}
</style>